import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Outlines } from '@react-three/drei'

import MeshSound from '../MeshSound'

export default function WardRobe({ ...props }) {
  const { currentIndex } = useSelector((state) => state.progress)
  const [isDoorOpen, setIsDoorOpen] = useState(false)
  const [isMusicBoxOutline, setIsMusicBoxOutline] = useState(false)
  const [isWardrobeOutline, setIsWardrobeOutline] = useState(false)

  useEffect(() => {
    if (
      currentIndex === props.index &&
      props.sceneAnims[4] &&
      props.sceneAnims[5] &&
      props.sceneAnims[6]
    ) {
      props.sceneAnims[4].play()
      props.sceneAnims[5].play()
      props.sceneAnims[6].play()
    }
  }, [props.sceneAnims, currentIndex])

  function onClick(e) {
    let timeout = null
    if (isDoorOpen) {
      props.onClick(e)
    } else {
      // TODO - Move this code outside, in AudioManager

      // create an audio in js and fire it
      const audio = new Audio('/sounds/doors.mp3')
      audio.play()
    }

    setIsDoorOpen(true)

    if (currentIndex === props.index) {
      props.sceneAnims[0].play()
      props.sceneAnims[1].play()

      // TODO - Clear this
      timeout = setTimeout(() => {
        props.sceneAnims[0].paused = true
        props.sceneAnims[1].paused = true
      }, 500)
    }
  }

  useEffect(() => {
    if (props.mode === 'inspection') {
      setIsMusicBoxOutline(false)
    }
  }, [props.mode])

  function onWardrobePointerEnter(e) {
    e.stopPropagation()
    if (currentIndex !== props.index || props.mode === 'inspection') return
    setIsWardrobeOutline(true)

    document.body.style.cursor = 'pointer'
  }

  function onWardrobePointerLeave(e) {
    e.stopPropagation()
    if (currentIndex !== props.index || props.mode === 'inspection') return
    setIsWardrobeOutline(false)

    document.body.style.cursor = 'default'
  }

  function onMusicBoxPointerEnter(e) {
    e.stopPropagation()
    if (currentIndex !== props.index || props.mode === 'inspection') return
    setIsMusicBoxOutline(true)

    document.body.style.cursor = 'pointer'
  }

  function onMusicBoxPointerLeave(e) {
    e.stopPropagation()
    if (currentIndex !== props.index || props.mode === 'inspection') return
    setIsMusicBoxOutline(false)

    document.body.style.cursor = 'default'
  }

  return (
    <>
      <mesh
        name="Wardrobe"
        geometry={props.nodes.Wardrobe.geometry}
        material={props.material}
        position={[3.663, 2.119, -4.015]}
        rotation={[Math.PI, -0.345, Math.PI]}
        scale={2.279}
        onClick={(e) => onClick(e)}
        onPointerEnter={(e) => !isDoorOpen && onWardrobePointerEnter(e)}
        onPointerLeave={(e) => !isDoorOpen && onWardrobePointerLeave(e)}
      >
        <mesh
          name="Left_door"
          geometry={props.nodes.Left_door.geometry}
          material={props.material}
          position={[0.184, 0.402, 0.343]}
        />
        <mesh
          name="Right_door004"
          geometry={props.nodes.Right_door004.geometry}
          material={props.material}
          position={[0.183, 0.317, -0.3]}
        />
        <Outlines
          thickness={
            !isDoorOpen && isWardrobeOutline && currentIndex === props.index
              ? 0.003
              : 0
          }
          color="white"
        />
      </mesh>

      <mesh
        name="MusicBox"
        geometry={props.nodes.MusicBox.geometry}
        material={props.material}
        position={[3.614, 2.81, -4.426]}
        scale={1.981}
        onClick={(e) => onClick(e)}
        onPointerEnter={(e) => onMusicBoxPointerEnter(e)}
        onPointerLeave={(e) => onMusicBoxPointerLeave(e)}
      >
        <Outlines
          thickness={
            isDoorOpen && isMusicBoxOutline && currentIndex === props.index
              ? 0.003
              : 0
          }
          color="white"
        />
        <group name="Anim" position={[-0.004, -0.02, 0.004]} scale={1.408}>
          <Outlines
            thickness={
              isDoorOpen && isMusicBoxOutline && currentIndex === props.index
                ? 0.003
                : 0
            }
            color="white"
          />
          <mesh
            name="Bananas001"
            geometry={props.nodes.Bananas001.geometry}
            material={props.material}
            position={[0.002, 0.153, 0.001]}
            rotation={[Math.PI, -0.92, Math.PI]}
            scale={0.75}
          >
            <Outlines
              thickness={
                isDoorOpen && isMusicBoxOutline && currentIndex === props.index
                  ? 0.003
                  : 0
              }
              color="white"
            />
          </mesh>
          <mesh
            name="Bananas002"
            geometry={props.nodes.Bananas002.geometry}
            material={props.material}
            position={[0, 0.16, 0.001]}
            rotation={[Math.PI, -0.92, Math.PI]}
            scale={0.75}
          >
            <Outlines
              thickness={
                isDoorOpen && isMusicBoxOutline && currentIndex === props.index
                  ? 0.003
                  : 0
              }
              color="white"
            />
          </mesh>
          <MeshSound index={props.index} />
        </group>
      </mesh>
    </>
  )
}
